import State from '../core/State';
import produce, { Draft } from 'immer';
import SalesByProductOrderTarget from '../types/SalesByProductOrderTarget';

export const setOrderBy = (orderBy: SalesByProductOrderTarget) =>
  produce((draft: Draft<State>) => {
    draft.orderBy = orderBy;
  });
